const OPS = ['+', '-', '*', '/'];
function isOp(ch) {
    return OPS.includes(ch);
}
function apply(a, op, b) {
    switch (op) {
        case '+': return a + b;
        case '-': return a - b;
        case '*': return a * b;
        case '/': return b === 0 ? null : a / b;
    }
}
/**
 * Разбирает строку на токены: числа и операторы.
 * Возвращает массив чередующихся number и Op, или null при ошибке.
 * Пример: "120+200*3" → [120, '+', 200, '*', 3]
 */
function tokenize(expr) {
    const trimmed = expr.trim();
    if (!trimmed)
        return null;
    const tokens = [];
    let i = 0;
    while (i < trimmed.length) {
        if (trimmed[i] === ' ') {
            i++;
            continue;
        }
        if (isOp(trimmed[i])) {
            // Минус в начале или после оператора — часть числа
            if (trimmed[i] === '-' && (tokens.length === 0 || typeof tokens[tokens.length - 1] === 'string')) {
                let num = '-';
                i++;
                while (i < trimmed.length && (trimmed[i] >= '0' && trimmed[i] <= '9' || trimmed[i] === '.')) {
                    num += trimmed[i++];
                }
                if (num === '-')
                    return null;
                tokens.push(parseFloat(num));
            }
            else {
                tokens.push(trimmed[i]);
                i++;
            }
        }
        else if ((trimmed[i] >= '0' && trimmed[i] <= '9') || trimmed[i] === '.') {
            let num = '';
            while (i < trimmed.length && (trimmed[i] >= '0' && trimmed[i] <= '9' || trimmed[i] === '.')) {
                num += trimmed[i++];
            }
            tokens.push(parseFloat(num));
        }
        else {
            return null; // недопустимый символ
        }
    }
    return tokens.length > 0 ? tokens : null;
}
/**
 * Вычисляет выражение слева направо (без приоритета операторов).
 * "120+200" → 320, "350*4+200" → 1600
 * Возвращает null если выражение невалидно.
 */
export function evaluateCalc(expr) {
    const tokens = tokenize(expr);
    if (!tokens || tokens.length === 0)
        return null;
    // Первый токен должен быть числом
    if (typeof tokens[0] !== 'number')
        return null;
    let result = tokens[0];
    for (let i = 1; i < tokens.length; i += 2) {
        const op = tokens[i];
        const num = tokens[i + 1];
        if (typeof op !== 'string' || typeof num !== 'number')
            return null;
        const r = apply(result, op, num);
        if (r === null)
            return null;
        result = r;
    }
    return isNaN(result) ? null : result;
}
/**
 * Обрабатывает ввод калькулятора при каждом onChange.
 * Если строка содержит паттерн "число оп число оп" в конце —
 * вычисляет накопленное и возвращает "результат + последний_оп".
 * "120+200+" → "320+"
 * "5.5*2-" → "11-"
 * Иначе возвращает строку как есть (отфильтровав мусор).
 */
export function processCalcInput(raw) {
    // Фильтруем недопустимые символы
    const value = raw.replace(/[^0-9.+\-*/]/g, '');
    if (!value)
        return '';
    const lastChar = value[value.length - 1];
    // Если последний символ — оператор
    if (isOp(lastChar)) {
        const exprPart = value.slice(0, -1);
        const tokens = tokenize(exprPart);
        // Если есть хотя бы "число оп число" — вычислить
        if (tokens && tokens.length >= 3) {
            const result = evaluateCalc(exprPart);
            if (result !== null) {
                // Форматируем: убираем лишние .0 для целых
                const str = Number.isInteger(result) ? String(result) : parseFloat(result.toFixed(10)).toString();
                return str + lastChar;
            }
        }
        // Не удалось вычислить или только одно число — оставляем как есть
        // Но не допускаем два оператора подряд
        if (value.length >= 2 && isOp(value[value.length - 2])) {
            // Заменяем предыдущий оператор на новый
            return value.slice(0, -2) + lastChar;
        }
        return value;
    }
    return value;
}
